const StockLabel = {
    NoStock: 'NO_STOCK',
    OneStock: 'ONE_STOCK',
    TwoStock: 'TWO_STOCK',
    ThreeStock: 'THREE_STOCK',
    FullStock: 'FULL_STOCK'
};

const getStockByStockLabel = label => {
    switch (label) {
        case StockLabel.NoStock:
            return 0;
        case StockLabel.OneStock:
            return 1;
        case StockLabel.TwoStock:
            return 2;
        case StockLabel.ThreeStock:
            return 3;
    }
};

export {
    StockLabel,
    getStockByStockLabel
};
